import usePopups from "@/stores/popupsStore"
import { defineComponent, Modal, type Popup, type ReactiveComponent } from "vue-utils"

const Popups: ReactiveComponent = () => {
	const popups = usePopups()

	return () => {
		if (!popups.topPopup.value) {
			return null
		}
		const Content = popups.topPopup.value.content
		return (
			<Modal
				zIndex={3}
				style={{
					minWidth: `min(${popups.topPopup.value.width ?? 28}rem, calc(100vw - 4rem))`,
					width: popups.topPopup.value.width ?? "22.5%",
				}}
				onCancel={(e) => {
					if (popups.topPopup.value?.closable) {
						popups.topPopup.value.onClose?.()
						popups.closePopup(popups.topPopup.value)
					} else {
						e.preventDefault()
					}
				}}
			>
				<Content close={() => popups.closePopup(popups.topPopup.value as Popup)} popup={popups.topPopup.value} />
			</Modal>
		)
	}
}

export default defineComponent(Popups)
